import React from 'react';

const statusStyles = {
  PENDING: 'bg-gray-200 text-gray-800',
  RUNNING: 'bg-green-100 text-green-800',
  STOPPING: 'bg-orange-100 text-orange-800',
  STOPPED: 'bg-slate-200 text-slate-800',
  ERROR: 'bg-red-100 text-red-800',
};

export default function StatusBadge({ status }) {
  const cls = statusStyles[status] || 'bg-gray-200 text-gray-800';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${cls}`}>
      {status}
      {(status === 'PENDING' || status === 'STOPPING') && (
        <svg className="ml-1 h-3 w-3 animate-spin text-current" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
        </svg>
      )}
    </span>
  );
}
